var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":_vm.containerId}},[_c('FilePicker',_vm._b({on:{"close":_vm.onClose}},'FilePicker',_vm.filepickerOptions,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }